module.exports = __webpack_public_path__ + "img/payok.2055bb59.png";